GloboSwatchConfig.settings = {
            enable_collection_page: true,
            enable_product_page: true,
            out_of_stock: "cross out",
            enable_mandatory: true,
            show_add_to_cart_button: true,
            add_to_cart_ajax: false,
            show_option_name: true,
            add_to_cart_text: "Add to cart",
            added_to_cart_text: "Added to cart",
            sold_out_text: "Sold out",
            text_required: "This field is required",
            sort_option: false,
            show_one_variant_product: true,
            show_one_variant_collection: false,
            group_image: false,
            show_limit_variant: false,
            limit_variant: "5",
        };
        GloboSwatchConfig.options = [];
        GloboSwatchConfig.product_page= {
                customize_swatch: {
                    swatch_shape: 'square',
                    swatch_size: 'large',
                    border_style: 'none',
                    border_color: {
                        normal: '#9b9b9b',
                        hover: '#58468c',
                        selected: '#58468c'
                    },
                    hover_effects:{
                        background: 'add shadow',
                        zoom_image: 'zoom',
                        size_change: 'increase size'
                    }
                },
                customize_button: {
                    button_corner: 'rounded',
                    button_size: 'large',
                    border_color: {
                        normal: '#000000',
                        hover: '#58468c',
                        selected: '#58468c'
                    },
                    text_style: 'default',
                    text_color: {
                        normal: '#000000',
                        hover: '#ffffff',
                        selected: '#ffffff'
                    },
                    background_color: {
                        normal: '#fff',
                        hover: '#58468c',
                        selected: '#58468c'
                    },
                    hover_effects:{
                        background: 'add shadow',
                    }
                },
                show_number_stock: '',
                float: 'left'
            };
            GloboSwatchConfig.collection_page ={
                customize_swatch: {
                    swatch_shape: 'circle',
                    swatch_size: 'medium',
                    border_style: 'double',
                    border_color: {
                        normal: '#9b9b9b',
                        hover: '#58468c',
                        selected: '#58468c'
                    },
                    hover_effects:{
                        background: 'no effect',
                        zoom_image: 'no zoom',
                        size_change: 'no change'
                    }
                },
                customize_button: {
                    button_corner: 'sharp',
                    button_size: 'medium',
                    border_color: {
                        normal: '#000000',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    text_style: 'default',
                    text_color: {
                        normal: '#0a0a0a',
                        hover: '#ffffff',
                        selected: '#ffffff'
                    },
                    background_color: {
                        normal: '#ffffff',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    hover_effects:{
                        background: 'no effect',
                    }
                },
                float: 'left',
                carousel: 'disable'
        };